import { useState, useEffect, useRef } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export function EmbedsSection() {
  const [embeds, setEmbeds] = useState([]);
  const containerRefs = useRef({});

  useEffect(() => {
    fetchEmbeds();
  }, []);

  const fetchEmbeds = async () => {
    try {
      const { data } = await axios.get(`${API}/api/embeds`);
      setEmbeds(data.filter(e => e.section === 'custom'));
    } catch (error) {
      console.log('No embeds loaded');
    }
  };

  useEffect(() => {
    // Execute scripts after embeds are loaded
    embeds.forEach(embed => {
      const container = containerRefs.current[embed.id];
      if (container) {
        // Clear previous content
        container.innerHTML = '';
        
        // Create a wrapper div for the embed
        const wrapper = document.createElement('div');
        wrapper.innerHTML = embed.embed_code;
        
        // Handle script tags
        const scripts = wrapper.querySelectorAll('script');
        scripts.forEach(oldScript => {
          const newScript = document.createElement('script');
          
          // Copy all attributes
          Array.from(oldScript.attributes).forEach(attr => {
            newScript.setAttribute(attr.name, attr.value);
          });
          
          // Copy inline script content if any
          if (oldScript.textContent) {
            newScript.textContent = oldScript.textContent;
          }
          
          // Replace old script with new one
          oldScript.parentNode?.replaceChild(newScript, oldScript);
        });
        
        container.appendChild(wrapper);
      }
    });
  }, [embeds]);

  if (embeds.length === 0) return null;

  return (
    <section 
      className="py-16 px-4 sm:px-6 lg:px-8 bg-black"
      data-testid="embeds-section"
    >
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="text-orange-500 font-semibold tracking-widest text-sm">CONTENIDO EXTERNO</span>
          <h2 
            className="text-3xl sm:text-4xl font-extrabold text-white mt-2"
            style={{ fontFamily: 'Barlow Condensed' }}
          >
            INSCRIPCIONES Y MÁS
          </h2>
        </div>

        <div className="space-y-8">
          {embeds.map((embed) => (
            <div 
              key={embed.id}
              className="bg-zinc-900/50 border border-white/10 rounded-xl p-6"
              data-testid={`embed-${embed.id}`}
            >
              <h3 className="text-xl font-bold text-white mb-4" style={{ fontFamily: 'Barlow Condensed' }}>
                {embed.title}
              </h3>
              <div 
                ref={el => containerRefs.current[embed.id] = el}
                className="embed-container min-h-[200px] flex items-center justify-center"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
